export const SET_SIGNATURE_STATE = 'SET_SIGNATURE_STATE';

export const setSignatureState = (signatureState) => ({
    type: SET_SIGNATURE_STATE,
    payload: signatureState,
});
